import React from 'react';
import { Progress } from 'antd';

const CustomProgress = props => <Progress {...props} />;

export default CustomProgress;
